export default __webpack_public_path__ + "static/media/004-Black Widow.37933c06.svg";